var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 69,
    viewBox: "0 0 72 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5972_29650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7139 31.7222C41.0556 31.7222 42.1444 32.8111 42.1444 34.1528V40.7486C42.1444 42.4066 41.4858 43.9966 40.3135 45.169C39.1411 46.3414 37.551 47 35.8931 47C34.2351 47 32.645 46.3414 31.4727 45.169C30.3003 43.9966 29.6417 42.4066 29.6417 40.7486V34.1528C29.6417 32.8111 30.7292 31.7222 32.0722 31.7222H39.7139ZM29.1264 31.7222C28.6403 32.3083 28.3278 33.0417 28.2653 33.8472L28.2514 34.1528V40.7486C28.2514 41.925 28.5181 43.0389 28.9931 44.0333C28.1698 44.2536 27.307 44.2815 26.4712 44.115C25.6355 43.9485 24.8492 43.592 24.1733 43.0731C23.4973 42.5543 22.9497 41.8868 22.5729 41.1225C22.196 40.3582 22 39.5174 22 38.6653V34.1528C22 33.5428 22.2294 32.9551 22.6426 32.5064C23.0558 32.0577 23.6226 31.7807 24.2306 31.7306L24.4306 31.7222H29.1264ZM42.6597 31.7222H47.3472C48.6889 31.7222 49.7778 32.8111 49.7778 34.1528V38.6667C49.778 39.5183 49.5824 40.3585 49.2061 41.1225C48.8298 41.8865 48.283 42.5538 47.6077 43.0727C46.9325 43.5917 46.147 43.9485 45.3119 44.1155C44.4769 44.2826 43.6146 44.2554 42.7917 44.0361C43.2083 43.1639 43.4639 42.2028 43.5208 41.1861L43.5333 40.7486V34.1528C43.5333 33.2292 43.2056 32.3819 42.6583 31.7222H42.6597ZM35.8889 22C36.994 22 38.0538 22.439 38.8352 23.2204C39.6166 24.0018 40.0556 25.0616 40.0556 26.1667C40.0556 27.2717 39.6166 28.3315 38.8352 29.1129C38.0538 29.8943 36.994 30.3333 35.8889 30.3333C34.7838 30.3333 33.724 29.8943 32.9426 29.1129C32.1612 28.3315 31.7222 27.2717 31.7222 26.1667C31.7222 25.0616 32.1612 24.0018 32.9426 23.2204C33.724 22.439 34.7838 22 35.8889 22ZM44.9167 23.3889C45.8376 23.3889 46.7207 23.7547 47.3719 24.4059C48.0231 25.057 48.3889 25.9402 48.3889 26.8611C48.3889 27.782 48.0231 28.6652 47.3719 29.3163C46.7207 29.9675 45.8376 30.3333 44.9167 30.3333C43.9958 30.3333 43.1126 29.9675 42.4614 29.3163C41.8103 28.6652 41.4444 27.782 41.4444 26.8611C41.4444 25.9402 41.8103 25.057 42.4614 24.4059C43.1126 23.7547 43.9958 23.3889 44.9167 23.3889ZM26.8611 23.3889C27.782 23.3889 28.6652 23.7547 29.3163 24.4059C29.9675 25.057 30.3333 25.9402 30.3333 26.8611C30.3333 27.782 29.9675 28.6652 29.3163 29.3163C28.6652 29.9675 27.782 30.3333 26.8611 30.3333C25.9402 30.3333 25.057 29.9675 24.4059 29.3163C23.7547 28.6652 23.3889 27.782 23.3889 26.8611C23.3889 25.9402 23.7547 25.057 24.4059 24.4059C25.057 23.7547 25.9402 23.3889 26.8611 23.3889Z",
    fill: "url(#paint0_linear_5972_29650)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5972_29650",
    x: -10.5,
    y: -11,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5972_29650"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5972_29650",
    result: "effect2_dropShadow_5972_29650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5972_29650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5972_29650",
    x1: -28.5076,
    y1: -14.3269,
    x2: 73.1106,
    y2: -34.5508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.d9607bf147c40c21010168c0b3d72db3.svg";
export { ForwardRef as ReactComponent };